import axios from "axios";
import { getAccessToken } from "./utils.js";
import { getUrl } from "./urls";
import { toast } from "react-toastify";
import { gettingStartedProgress } from "./globalAction";
import { STORE_PAGES_LIST } from "../reducers/facebookPagesModalReducer.js";
export const FETCH_FB_TOKENS = "FETCH_FB_TOKENS";
export const FETCH_IG_TOKENS = "FETCH_IG_TOKENS";
export const FETCH_LINKEDIN_TOKENS = "FETCH_LINKEDIN_TOKENS";

export const FETCH_TWITTER_OAUTH_TOKEN = "FETCH_TWITTER_OAUTH_TOKEN";
export const TWITTER_AUTHENTICATE = "TWITTER_AUTHENTICATE";
export const TIKTOK_AUTHENTICATE = "TIKTOK_AUTHENTICATE";
export const LINKEDIN_AUTHENTICATE = "LINKEDIN_AUTHENTICATE";
export const FETCH_TOKEN_LIST = "FETCH_TOKEN_LIST";
export const FETCH_AD_ACCOUNT_LIST = "FETCH_AD_ACCOUNT_LIST";
export const GET_LINKEDIN_PAGE_LIST = "GET_LINKEDIN_PAGE_LIST";

export function fetchLkdnTokenList() {
    let res = axios
        .get(getUrl("getLkdnTokens"), {
            cache: false,
            headers: { "Content-Type": "application/json; charset=UTF-8" },
        })
        .then((response) => response.data)
        .catch((err) => {
            toast.error(err.response.data.message);
            throw err;
        });
    return {
        type: FETCH_LINKEDIN_TOKENS,
        payload: res,
    };
}

export function storeLkdnToken(currentUrl, redirectUrl) {
    return function (dispatch) {
        axios
            // .get("https://api2.circussocial.com/linkedin-auth-callback?access-token=" + getAccessToken() + "&" + currentUrl + "&redirect_url=" + redirectUrl, {
            .get(getUrl("storeLkdnToken") + "&" + currentUrl + "&redirect_url=" + redirectUrl, {
                cache: false,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            })
            .then((resp) => {
                toast.success("Your authorization is successful.");
                window.history.replaceState(null, "", "http://localhost:3000/tokens");
                // window.location.href =
                // window.location.origin + window.location.pathname;
                dispatch(fetchLkdnTokenList());
                dispatch(gettingStartedProgress());
            })
            .catch((err) => {
                toast.error(err.message);
                window.history.replaceState(null, "", "http://localhost:3000/tokens");
            });
    };
}

// CENTRAL TOKEN

export function storeFbSocialToken(userDetails) {
    return function (dispatch) {
        return axios
            .get(`https://graph.facebook.com/me/accounts?access_token=${userDetails.accessToken}`, {
                cache: false,
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                },
            })
            .then((api_data) => {
                // if (api_data.data.data.length > 0) {
                let pages = [];
                api_data.data.data.map((value) => {
                    if (value.id && value.id !== "") pages.push({ ...value });
                });

                if (pages.length == 0) {
                    toast.error("You do not have any valid Facebook pages.");
                }
                else {
                    dispatch({ type: STORE_PAGES_LIST, pages, userDetails })
                }
                // );
                // }
                // } else {
                //     toast.error("You do not have any valid Facebook pages.");
                // }
            })
            .catch((err) => {
                console.log("Error in graph api", err);
            });
    };
}

export function storeIgSocialToken(userDetails, fetchList = true) {
    return function (dispatch) {
        return axios
            .get(`https://graph.facebook.com/me/accounts?fields=name,instagram_business_account&access_token=${userDetails.accessToken}`, {
                cache: false,
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                },
            })
            .then((api_data) => {
                if (api_data.data.data.length > 0) {
                    let pages = [];

                    api_data.data.data.map((value) => {
                        if (value.instagram_business_account)
                            pages.push({
                                page_id: value.instagram_business_account.id,
                            });
                    });
                    if (pages.length == 0) {
                        toast.error("You do not have access to any valid Instagram Business Accounts.");
                        return api_data;
                    } else {
                        // return dispatch(
                        return axios
                            .post(
                                getUrl("store_central_social_token"),
                                {
                                    platform_id: "6ce32c0a-a789-11e4-a34f-74867a1157ba",
                                    pages: pages,
                                    app_name: "20twentyIGApp",
                                    access_token: userDetails.accessToken,
                                },
                                {
                                    cache: false,
                                    headers: {
                                        "Content-Type": "application/json; charset=UTF-8",
                                        access_token: getAccessToken(),
                                    },
                                },
                            )
                            .then(function (res) {
                                toast.success("Your authorization was successful.");
                                if (fetchList) {
                                    dispatch(fetchTokenList());
                                    dispatch(fetchIgTokenList());
                                    dispatch(gettingStartedProgress());
                                }

                                return res;
                            })
                            .catch(function (err) {
                                dispatch(fetchTokenList());
                                dispatch(fetchIgTokenList());
                                if (err.response.data.message) {
                                    toast.error(err.response.data.message);
                                } else {
                                    toast.error("Error in Authorizing");
                                }
                            });
                        // );
                    }
                } else {
                    toast.error("You do not have access to any valid Instagram Business Accounts.");
                    return api_data;
                }
            })
            .catch((err) => {
                console.log("Error in graph api", err);
            });
    };
}

export function tiktokAuthentication(param) {
    let res = axios({
        method: "POST",
        url: `${getUrl("tiktok_authenticate")}`,
        headers: {
            "Content-Type": "application/json",
            cache: false,
        },
        data: param,
    })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            console.error("res err", err);
            err?.response?.data?.message ? toast.error(err?.response?.data?.message) : toast.error("Error in Authenticating");
            // toast.error("Error in Authenticating");
        });
    return {
        type: "TIKTOK_AUTHENTICATE",
        payload: res,
    };
}

export function getLinkedinPages(params) {
    let url = `${getUrl("get_linkedin_pages")}?code=${params.code}&redirect_url=${params.redirect_url}`;
    let req = axios
        .get(url, {
            headers: {
                "Content-Type": "application/json",
                "access-token": getAccessToken(),
            },
        })
        .then((response) => {
            return response.data?.data;
        })
        .catch((error) => {
            console.error(error.response.data.message);
            return error;
            // throw error;
        });

    return {
        type: "GET_LINKEDIN_PAGE_LIST",
        payload: req,
    };
}

export function linkedinAuthentication(param) {
    let res = axios({
        method: "POST",
        url: `${getUrl("linkedin_authenticate")}`,
        headers: {
            "Content-Type": "application/json",
            cache: false,
        },
        data: param,
    })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            console.error("res err", err);
            err?.response?.data?.message ? toast.error(err?.response?.data?.message) : toast.error("Error in Authenticating");
        });
    return {
        type: "LINKEDIN_AUTHENTICATE",
        payload: res,
    };
}

export function fetchTwitteroAuthToken(param) {
    console.log("first", param);
    let res = axios({
        method: "GET",
        url: `${getUrl("twitter_oauth_token")}&redirect_target=${param}`,
        headers: {
            "Content-Type": "application/json",
            cache: false,
        },
    })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            return err;
        });
    return {
        type: "FETCH_TWITTER_OAUTH_TOKEN",
        payload: res,
    };
}

export function twitterAuthenticate(params) {
    let res = axios({
        method: "POST",
        url: getUrl("twitter_authenticate"),
        headers: {
            "Content-Type": "application/json",
            cache: false,
        },
        data: params,
    })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            return err;
        });
    return {
        type: "TWITTER_AUTHENTICATE",
        payload: res,
    };
}

export function fetchTokenList() {
    let res = axios
        .get(getUrl("social_token_list"), {
            cache: false,
            headers: { "Content-Type": "application/json; charset=UTF-8" },
        })
        .then((response) => response.data.data.tokens)
        .catch((err) => {
            toast.error(err?.response?.data?.message);
            throw err;
        });
    return {
        type: FETCH_TOKEN_LIST,
        payload: res,
    };
}

export function fetchFbTokenList() {
    let res = axios
        .get(getUrl("social_token_list"), {
            cache: false,
            headers: { "Content-Type": "application/json; charset=UTF-8" },
        })
        .then((response) => response.data?.data?.tokens?.filter((token) => token.platform === "facebook"))
        .catch((err) => {
            toast.error(err.response.data.message);
            throw err;
        });
    return {
        type: FETCH_FB_TOKENS,
        payload: res,
    };
}

export function fetchIgTokenList() {
    let res = axios
        .get(getUrl("social_token_list"), {
            cache: false,
            headers: { "Content-Type": "application/json; charset=UTF-8" },
        })
        .then((response) => response.data?.data?.tokens?.filter((token) => token.platform === "instagram"))
        .catch((err) => {
            toast.error(err.response.data.message);
            throw err;
        });
    return {
        type: FETCH_IG_TOKENS,
        payload: res,
    };
}

export function getAdAccountList(social_id) {
    let res = axios
        .get(getUrl("ad_account_list") + `user_social_id=${social_id}`, {
            cache: false,
            headers: { "Content-Type": "application/json; charset=UTF-8" },
        })
        .then((response) => response.data?.data?.ad_accounts)
        .catch((err) => {
            toast.error(err.response.data.message);
            throw err;
        });
    return {
        type: FETCH_AD_ACCOUNT_LIST,
        payload: res,
    };
}

export function toggleTokenStatus(params) {
    let res = axios({
        method: "POST",
        url: `${getUrl("toggleTokenStatus")}`,
        headers: {
            "Content-Type": "application/json",
            cache: false,
        },
        data: params,
    })
        .then((res) => {
            let successMsg = params?.status === "Active" ? "Token resumed successfully" : "Token paused successfully";
            toast.success(successMsg);
            return res.data;
            // console.log(res.data);
        })
        .catch((err) => {
            console.error(err.response?.data?.message);
            toast.error(err.response?.data?.message);
            // toast.error("Error. Please try Again");
        });
    return {
        type: "TOGGLE_TOKEN_STATUS",
        payload: res,
    };
}

export function revokeToken(params) {
    let res = axios({
        method: "POST",
        url: `${getUrl("revokeToken")}`,
        headers: {
            "Content-Type": "application/json",
            cache: false,
        },
        data: params,
    })
        .then((res) => {
            toast.success("Page revoked successfully.");
            // return res.data;
        })
        .catch((err) => {
            console.error(err.response?.data?.message);
            toast.error(err.response?.data?.message);
            // toast.error("Error. Please try Again");
        });
    return {
        type: "REVOKE_TOKEN",
        payload: res,
    };
}
